/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './deleteMember.defs.js'
export * as $defs from './deleteMember.defs.js'
